module.exports = __webpack_public_path__ + "static/img/MICHAEL-RUDD.1421541.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MICHAEL-RUDD.jpg
// module id = RKcU
// module chunks = 0